import { Card as SemanticCard } from 'semantic-ui-react'
import type { CSSProperties, ReactNode, SyntheticEvent } from 'react'

import {
  StyledCard,
  CardWithTopBorder,
  StyledGroup,
  StyledHeader,
} from './Styles'

interface CardProps {
  fluid?: boolean
  transition?: boolean
  useTopBorder?: boolean
  children?: ReactNode
  style?: CSSProperties
  onClick?: (event: SyntheticEvent, data: object) => void
}

const Card = ({ transition, useTopBorder, ...props }: CardProps) => {
  if (useTopBorder) {
    return <CardWithTopBorder {...props} />
  }

  return <StyledCard {...props} />
}

Card.Group = StyledGroup
Card.Header = StyledHeader
Card.Content = SemanticCard.Content
Card.Description = SemanticCard.Description
Card.Meta = SemanticCard.Meta

export default Card
